import cn from "@/v2-ui/utils/utils.cn"
import { DotText } from "@/v2-backoffice-client/components/dot"
import InfoGrid, {
  type InfoGridProps,
  createInfoGridFields,
} from "@/v2-backoffice-client/components/infoGrid"
import type { LayerCategoryFragment } from "@/v2-backoffice-client/layer/category/__types__/layer.category.fragment"

const FIELDS = createInfoGridFields<LayerCategoryFragment>({
  fields: {
    FeatureCode: {
      label: "Feature Code",
      accessor: "FeatureCode",
      renderValue: ({ value }) => (
        <span className="font-mono text-xs">{String(value)}</span>
      ),
    },
    Priority: {
      label: "Priority",
      accessor: "Priority",
    },
    IsEnabled: {
      label: "Status",
      accessor: "IsEnabled",
      renderValue: ({ value }) => (
        <DotText variant={value ? "success-1" : "destructive"}>
          {value ? "Enabled" : "Disabled"}
        </DotText>
      ),
    },
    Description: {
      label: "Description",
      accessor: "Description",
      show: (data) => !!data.Description,
      renderValue: ({ value }) => {
        if (!value) return
        return <span className="text-xs">{String(value)}</span>
      },
    },
  },
})

export type LayerCatgoryViewInfoProps = Omit<
  InfoGridProps<LayerCategoryFragment>,
  "data" | "fields"
> & {
  category: LayerCategoryFragment | null | undefined
}

function LayerCatgoryViewInfo(props: LayerCatgoryViewInfoProps) {
  const { category, className, ...infoGridProps } = props
  return (
    <InfoGrid
      id="layer-category-info"
      className={cn("layer-category-view-info", className)}
      data={category}
      fields={FIELDS}
      {...infoGridProps}
    />
  )
}

export default LayerCatgoryViewInfo
